import { authenticatedFetch } from '../auth/authClient';

/**
 * One schedule row edited in place on the record page: a field the related
 * list edits (period_start, period_end, amount, hours). Throws the server's
 * message, which the cell shows.
 */
export async function patchScheduleRow(opportunityId: string, rowId: string, key: string, value: string | null): Promise<void> {
  const body = key === 'amount' || key === 'hours' ? { [key]: value === null || value.trim() === '' ? null : Number(value) } : { [key]: value };
  const res = await authenticatedFetch(
    `/api/opportunities/${encodeURIComponent(opportunityId)}/revenue-schedules/${encodeURIComponent(rowId)}`,
    { method: 'PATCH', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) },
  );
  if (!res.ok) {
    const data = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(data?.error ?? `Could not save the row (${res.status}).`);
  }
}
